import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { ButtonComponent } from '@banyan/modules/standalone/button/button.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-horizontal-step-card',
  templateUrl: './horizontal-step-card.component.html',
  styleUrls: ['./horizontal-step-card.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    TranslateModule,
    ButtonComponent,
    RouterModule,
  ],
})
export class HorizontalStepCardComponent {
  @Input() svgIcon: string = '';
  @Input() title: string = '';
  @Input() description: string = '';
  @Input() textLink: string = '';
  @Input() link: string = '';
  @Input() text: string = '';
  @Input() urlLink: string = '';
}
